import { Checkbox, FormControlLabel } from "@mui/material";
import { RuleConstraint } from "../../../types";
import { useRulesContext } from "../../../_context/RulesContext";

const ConstraintCheckbox = ({
    value,
    label,
    onChange
}: {
    value: RuleConstraint,
    label: string,
    onChange: (value: RuleConstraint, checked: boolean) => void
}) => {

    const { constraints } = useRulesContext();

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={Boolean(constraints.find(c => c === value))}
                    onChange={(e, checked) => onChange(value, checked)}
                />
            }
            label={label}
        />
    )
};

export default ConstraintCheckbox;